var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 50.8848V50.8848C30.3186 50.8848 30.5769 51.1431 30.5769 51.4617V51.4617C30.5769 51.7803 30.3186 52.0386 30 52.0386V52.0386C29.6814 52.0386 29.4231 51.7803 29.4231 51.4617V51.4617C29.4231 51.1431 29.6814 50.8848 30 50.8848",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8C15 5.23858 17.2386 3 20 3H40C42.7614 3 45 5.23858 45 8V51.0769C45 53.8383 42.7614 56.0769 40 56.0769H20C17.2386 56.0769 15 53.8384 15 51.0769V8Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 46.8457H15",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 12.2305H15",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5385 7.61523H33.4615",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0071 33.0005V19.1543",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30 38.1914C30.3186 38.1914 30.5769 38.4497 30.5769 38.7683C30.5769 39.087 30.3186 39.3453 30 39.3453C29.6814 39.3453 29.4231 39.087 29.4231 38.7683C29.4231 38.4497 29.6814 38.1914 30 38.1914",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotes);
export default __webpack_public_path__ + "static/media/icon-notes.f8c4d8bd.svg";
export { ForwardRef as ReactComponent };